{
	"paymentMethods": {
		"app": "App",
		"money": "Cash",
		"check": "Check",
		"boleto": "Bank slip",
		"creditCard": "Credit card",
		"bankTransfer": "Bank transfer",
		"promissory": "Promissory",
		"debitCard": "Debit card",
		"automaticDebit": "Automatic debit"
	},
	"description": "Description",
	"descriptionPlaceholder": "Enter a description",
	"performDate": "Perform date",
	"dueDate": "Due date",
	"account": "Account",
	"accountPlaceholder": "Select an account",
	"value": "Value",
	"toPay": "Pay",
	"toReceive": "To receive",
	"costCenter": "Cost center",
	"costCenterPlaceholder": "Select a cost center",
	"billType": "Type",
	"billtypePlaceholder": "Select a type",
	"supplier": "Supplier",
	"supplierPlaceholder": "Select a supplier",
	"paymentMethod": "Payment method",
	"paymentMethodPlaceholder": "Select a payment method",
	"payDate": "Payday",
	"reconciled": "Reconciled",
	"status": "Paid",
	"observation": "Observation",
	"billAttachmentSize": "File too large (max 20 MB)",
	"loading": "Loading...",
	"attachment": "Attachment",
	"deleteBill": "Are you sure you want to delete this account?",
	"validateField": "Required field",
	"invalidValue": "Invalid value"
}
